import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $paymentsByRecipientId } from '@lib/store';
import { useListState } from '@shared/hooks';
import { cn, PaletteUtils } from '@shared/utils';
import type { RecipientResponse } from '@shared/api';
import { RecipientTable } from './recipientTable';
import { Text } from '@shared/widgets';

interface RecipientTransactionProps {
  className?: string;
  recipient: RecipientResponse;
}

export const RecipientTransaction = (props: RecipientTransactionProps) => {
  const paymentsByRecipientId = useUnit($paymentsByRecipientId.store);

  const recipientTransactionsState = useListState({ list: 'recipientTransactions' });
  const { t } = useTranslation('recipient');

  useEffect(() => {
    return () => $paymentsByRecipientId.events.clear();
  }, []);

  useEffect(() => {
    if (!props.recipient.id) return;
    $paymentsByRecipientId.events.getPaymentsByRecipientId({
      RecipientId: props.recipient.id,
      Count: recipientTransactionsState.count,
      FromIndex: recipientTransactionsState.fromIndex,
    });
  }, [props.recipient?.id, recipientTransactionsState]);

  return (
    <section
      className={cn(
        'flex flex-col gap-6',
        PaletteUtils.isVcfcPalette && 'rounded-xl bg-white p-7 dark:border dark:border-gray-black dark:bg-soft-black',
        props.className,
      )}
    >
      <Text weight='semibold' size='2xl'>
        {t('transaction.title')}
      </Text>
      <RecipientTable
        isLoading={paymentsByRecipientId.loading}
        error={paymentsByRecipientId.error}
        onRefresh={() =>
          $paymentsByRecipientId.events.getPaymentsByRecipientId({
            RecipientId: props.recipient.id,
            Count: recipientTransactionsState.count,
            FromIndex: recipientTransactionsState.fromIndex,
          })
        }
        data={paymentsByRecipientId.data?.data}
        totalItemCount={paymentsByRecipientId.data.total}
        currentPage={recipientTransactionsState.page}
        countItemPage={recipientTransactionsState.count}
        onChangePage={recipientTransactionsState.onChangePage}
        onChangeCountItemPage={recipientTransactionsState.onChangeCount}
      />
    </section>
  );
};
